import * as React from 'react';
import { Modal, Button } from 'react-bootstrap';

type Props = {
  show: boolean;
  title: string;
  text: string;
  link: string;
  linkText: string;
  additionalLink?: string;
  additionalLinkText?: string;
  onHide: () => void;
};

type State = {
  show: boolean;
};

export class GenericModal extends React.Component<Props, {}> {
  state: State  = {
    show: this.props.show
  };

  componentWillReceiveProps(nextProps: Props) {
    this.setState({
      show: nextProps.show
    });
  }

  handleClose = () => {
    this.props.onHide();
  }

  openWindow = (link, event) => {
    event.preventDefault();
    window.open(link);
  }

  render() {
    console.log('GenericModal is rendering....');
    if (!this.state.show) {
      return null;
    }

    const { title, text, link, linkText, additionalLink, additionalLinkText } = this.props;
    
    return (
      <Modal show={this.state.show} onHide={this.handleClose}>
        <Modal.Header closeButton style={{ backgroundColor: '#337ab7', color: '#fff' }}>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            {text}
          </p>
          <p>
            <a href={link} onClick={(event)=>this.openWindow(link, event)}>{linkText}</a>
          </p>
          {additionalLink && additionalLinkText && (
            <p>
              <a href={additionalLink} onClick={(event)=>this.openWindow(additionalLink, event)}>{additionalLinkText}</a>
            </p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={this.handleClose}>Close</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}
